/**
 * Media utilities: media extensions (from xconfig, see media-extensions.ts) and type detection.
 *
 * @module media
 */

// Extension registry
export {
    // Image extensions
    IMAGE_EXTENSIONS,

    // Audio extensions
    AUDIO_EXTENSIONS,

    // Video extensions
    VIDEO_EXTENSIONS,

    // Document & other extensions
    ARCHIVE_EXTENSIONS,
    DOCUMENT_EXTENSIONS,
    EBOOK_EXTENSIONS,
    PRESENTATION_EXTENSIONS,
    VECTOR_EXTENSIONS,
    PDF_EXTENSIONS,
    PS_EXTENSIONS,
    MS_OFFICE_EXTENSIONS,

    // Aggregated sets
    ALL_EXTENSIONS,
    ALL_EXTENSIONS_SET,
    THUMBNAIL_SUPPORTED_EXTENSIONS,
    THUMBNAIL_SUPPORTED_EXTENSIONS_SET,
    DISALLOWED_EXTENSIONS,

    // Types
    type ImageExtension,
    type AudioExtension,
    type VideoExtension,
    type ArchiveExtension,
    type DocumentExtension,
    type AllExtension,
} from './media-extensions';

// Media type detection
export {
    isVideoToType,
    isAudioToType,
    isImageToType,
    isVideoFromType,
    isAudioFromType,
    isImageFromType,
    detectMediaType,
    isVideoExtension,
    isAudioExtension,
    isImageExtension,
} from './media-type-detector';
